module.exports = __webpack_public_path__ + "static/main-img-services-6c6eb0e699e5986b495536230dc0625d.jpg";